// export const api_url = "http://localhost:5000"
export const api_url = "https://brands-backend-6a1k.onrender.com"

export const niches = [
    { id: 'niche1', name: 'Fashion' },
    { id: 'niche2', name: 'Technology' },
    { id: 'niche3', name: 'Travel' },
    { id: 'niche4', name: 'Food' },
    { id: 'niche5', name: 'Fitness' },
    { id: 'niche6', name: 'Beauty' },
    { id: 'niche7', name: 'Gaming' },
    { id: 'niche8', name: 'Education' },
    { id: 'niche9', name: 'Lifestyle' },
    { id: 'niche10', name: 'Finance' },
    { id: 'niche11', name: 'Health' },
    { id: 'niche12', name: 'Music' },
    { id: 'niche13', name: 'Sports' },
    { id: 'niche14', name: 'Movies' },
    { id: 'niche15', name: 'Photography' },
    { id: 'niche16', name: 'Art' },
    { id: 'niche17', name: 'Parenting' },
    { id: 'niche18', name: 'Books' },
    { id: 'niche19', name: 'Politics' },
    { id: 'niche20', name: 'Automotive' },
];

export const follower=[
    {
        name:"0-100k"
    },
    {
        name:"100k-200k"
    },
    {
        name:"200k-300k"
    },
    {
        name:"300k-400k"
    },
    {
        name:"400k-500k"
    },
    {
        name:"500k-600k"
    },
    {
        name:"600k-700k"
    },
    {
        name:"700k-800k"
    },
    {
        name:"800k+"
    }
]